<template>
  <div class="mt-5">
    <h2 class="text-xl font-extrabold text-center">{{ title }}</h2>
    <div class="mt-5 flex justify-center">
      <InputText class="questionInputText" placeholder="Vpišite vaš odgovor" v-model="text" @change="change"/>
    </div>
  </div>
</template>

<script>

import InputText from '@/components/InputText.vue'

export default {
  name: 'SurveyQuestionText',
  components: { InputText },
  props: {
    title: {},
    options: {},
    questionId: {},
    initialValue: {
      default: null
    },
  },
  data () {
    return {
      text: null,
    }
  },
  created () {
    if (this.initialValue) {
      this.selected = this.initialValue
      this.change()
    }
  },
  methods: {
    change () {
      let value = {
        'text': this.text,
        'questionId': this.questionId
      }
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="css">

.questionInputText {
  @apply w-full lg:w-1/2;
}


</style>
